/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardRedirectRouteImport } from './routes/onboard-redirect'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppVesselsRouteImport } from './routes/_app.vessels'
import { Route as AppUsersRouteImport } from './routes/_app.users'
import { Route as AppSupplierGroupsRouteImport } from './routes/_app.supplier-groups'
import { Route as AppStatisticsRouteImport } from './routes/_app.statistics'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppSearchRouteImport } from './routes/_app.search'
import { Route as AppRequestsForQuotesRouteImport } from './routes/_app.requests-for-quotes'
import { Route as AppProductsRouteImport } from './routes/_app.products'
import { Route as AppPortsRouteImport } from './routes/_app.ports'
import { Route as AppOrdersRouteImport } from './routes/_app.orders'
import { Route as AppOffersRouteImport } from './routes/_app.offers'
import { Route as AppMembersRouteImport } from './routes/_app.members'
import { Route as AppMeRouteImport } from './routes/_app.me'
import { Route as AppKeyPortsRouteImport } from './routes/_app.key-ports'
import { Route as AppIntegrationsRouteImport } from './routes/_app.integrations'
import { Route as AppDemandDefinitionsRouteImport } from './routes/_app.demand-definitions'
import { Route as AppDemandRouteImport } from './routes/_app.demand'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCustomersRouteImport } from './routes/_app.customers'
import { Route as AppCustomerGroupsRouteImport } from './routes/_app.customer-groups'
import { Route as AppContractsRouteImport } from './routes/_app.contracts'
import { Route as AppCompareRouteImport } from './routes/_app.compare'
import { Route as AppAssignmentsRouteImport } from './routes/_app.assignments'
import { Route as AppSupplierGroupsIndexRouteImport } from './routes/_app.supplier-groups.index'
import { Route as AppRequestsForQuotesIndexRouteImport } from './routes/_app.requests-for-quotes.index'
import { Route as AppMembersIndexRouteImport } from './routes/_app.members.index'
import { Route as AppDemandDefinitionsIndexRouteImport } from './routes/_app.demand-definitions.index'
import { Route as AppCustomerGroupsIndexRouteImport } from './routes/_app.customer-groups.index'
import { Route as AppContractsIndexRouteImport } from './routes/_app.contracts.index'
import { Route as AppAgentsIndexRouteImport } from './routes/_app.agents.index'
import { Route as OnboardUserIdTokenRouteImport } from './routes/onboard.$userId.$token'
import { Route as OfferOfferIdApprovalRequestRouteImport } from './routes/offer.$offerId.approval-request'
import { Route as AppVesselIdRouteImport } from './routes/_app.vessel.$id'
import { Route as AppSupplierGroupsGroupIdRouteImport } from './routes/_app.supplier-groups.$groupId'
import { Route as AppSupplierGroupIdRouteImport } from './routes/_app.supplier-group.$id'
import { Route as AppRequestsForQuotesIdRouteImport } from './routes/_app.requests-for-quotes.$id'
import { Route as AppOrdersNewRouteImport } from './routes/_app.orders_.new'
import { Route as AppOrderIdRouteImport } from './routes/_app.order.$id'
import { Route as AppOfferIdRouteImport } from './routes/_app.offer.$id'
import { Route as AppMembersIdRouteImport } from './routes/_app.members.$id'
import { Route as AppCustomerGroupsGroupIdRouteImport } from './routes/_app.customer-groups.$groupId'
import { Route as AppCustomerGroupIdRouteImport } from './routes/_app.customer-group.$id'
import { Route as AppContractsIdRouteImport } from './routes/_app.contracts.$id'
import { Route as AppAgentsIdRouteImport } from './routes/_app.agents.$id'
import { Route as AppSupplierGroupsGroupIdIndexRouteImport } from './routes/_app.supplier-groups.$groupId.index'
import { Route as AppCustomerGroupsGroupIdIndexRouteImport } from './routes/_app.customer-groups.$groupId.index'
import { Route as AppUserDetailIdRouteImport } from './routes/_app.user.detail.$id'
import { Route as AppSupplierDetailIdRouteImport } from './routes/_app.supplier.detail.$id'
import { Route as AppSupplierGroupsGroupIdMembersRouteImport } from './routes/_app.supplier-groups.$groupId.members'
import { Route as AppSupplierGroupsGroupIdCompaniesRouteImport } from './routes/_app.supplier-groups.$groupId.companies'
import { Route as AppRequestsForQuotesIdQuoteRouteImport } from './routes/_app.requests-for-quotes.$id_.quote'
import { Route as AppPortDetailIdRouteImport } from './routes/_app.port.detail.$id'
import { Route as AppOrdersDraftIdRouteImport } from './routes/_app.orders_.draft.$id'
import { Route as AppOrderEditIdRouteImport } from './routes/_app.order_.edit.$id'
import { Route as AppOfferIdQuoteRouteImport } from './routes/_app.offer.$id_.quote'
import { Route as AppOfferIdEditRouteImport } from './routes/_app.offer.$id_.edit'
import { Route as AppDemandDefinitionsCreateSubstepRouteImport } from './routes/_app.demand-definitions.create.$substep'
import { Route as AppCustomerDetailIdRouteImport } from './routes/_app.customer.detail.$id'
import { Route as AppCustomerGroupsGroupIdMembersRouteImport } from './routes/_app.customer-groups.$groupId.members'
import { Route as AppCustomerGroupsGroupIdCompaniesRouteImport } from './routes/_app.customer-groups.$groupId.companies'
import { Route as AppSupplierGroupsGroupIdMembersIndexRouteImport } from './routes/_app.supplier-groups.$groupId.members.index'
import { Route as AppSupplierGroupsGroupIdCompaniesIndexRouteImport } from './routes/_app.supplier-groups.$groupId.companies.index'
import { Route as AppCustomerGroupsGroupIdMembersIndexRouteImport } from './routes/_app.customer-groups.$groupId.members.index'
import { Route as AppCustomerGroupsGroupIdCompaniesIndexRouteImport } from './routes/_app.customer-groups.$groupId.companies.index'
import { Route as AppSupplierGroupsGroupIdMembersUserIdRouteImport } from './routes/_app.supplier-groups.$groupId.members.$userId'
import { Route as AppSupplierGroupsGroupIdCompaniesCompanyIdRouteImport } from './routes/_app.supplier-groups.$groupId.companies.$companyId'
import { Route as AppDemandDefinitionsEditDefinitionIdSubstepRouteImport } from './routes/_app.demand-definitions.edit.$definitionId.$substep'
import { Route as AppCustomerGroupsGroupIdMembersUserIdRouteImport } from './routes/_app.customer-groups.$groupId.members.$userId'
import { Route as AppCustomerGroupsGroupIdCompaniesCompanyIdRouteImport } from './routes/_app.customer-groups.$groupId.companies.$companyId'

const OnboardRedirectRoute = OnboardRedirectRouteImport.update({
  id: '/onboard-redirect',
  path: '/onboard-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVesselsRoute = AppVesselsRouteImport.update({
  id: '/vessels',
  path: '/vessels',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsRoute = AppSupplierGroupsRouteImport.update({
  id: '/supplier-groups',
  path: '/supplier-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsForQuotesRoute = AppRequestsForQuotesRouteImport.update({
  id: '/requests-for-quotes',
  path: '/requests-for-quotes',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppPortsRoute = AppPortsRouteImport.update({
  id: '/ports',
  path: '/ports',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersRoute = AppOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppKeyPortsRoute = AppKeyPortsRouteImport.update({
  id: '/key-ports',
  path: '/key-ports',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppDemandDefinitionsRoute = AppDemandDefinitionsRouteImport.update({
  id: '/demand-definitions',
  path: '/demand-definitions',
  getParentRoute: () => AppRoute,
} as any)
const AppDemandRoute = AppDemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerGroupsRoute = AppCustomerGroupsRouteImport.update({
  id: '/customer-groups',
  path: '/customer-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsRoute = AppContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AppRoute,
} as any)
const AppCompareRoute = AppCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AppRoute,
} as any)
const AppAssignmentsRoute = AppAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsIndexRoute = AppSupplierGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupplierGroupsRoute,
} as any)
const AppRequestsForQuotesIndexRoute =
  AppRequestsForQuotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRequestsForQuotesRoute,
  } as any)
const AppMembersIndexRoute = AppMembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMembersRoute,
} as any)
const AppDemandDefinitionsIndexRoute =
  AppDemandDefinitionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDemandDefinitionsRoute,
  } as any)
const AppCustomerGroupsIndexRoute = AppCustomerGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerGroupsRoute,
} as any)
const AppContractsIndexRoute = AppContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppContractsRoute,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const OnboardUserIdTokenRoute = OnboardUserIdTokenRouteImport.update({
  id: '/onboard/$userId/$token',
  path: '/onboard/$userId/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferOfferIdApprovalRequestRoute =
  OfferOfferIdApprovalRequestRouteImport.update({
    id: '/offer/$offerId/approval-request',
    path: '/offer/$offerId/approval-request',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppVesselIdRoute = AppVesselIdRouteImport.update({
  id: '/vessel/$id',
  path: '/vessel/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsGroupIdRoute =
  AppSupplierGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AppSupplierGroupsRoute,
  } as any)
const AppSupplierGroupIdRoute = AppSupplierGroupIdRouteImport.update({
  id: '/supplier-group/$id',
  path: '/supplier-group/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsForQuotesIdRoute = AppRequestsForQuotesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppRequestsForQuotesRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders_/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOrderIdRoute = AppOrderIdRouteImport.update({
  id: '/order/$id',
  path: '/order/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOfferIdRoute = AppOfferIdRouteImport.update({
  id: '/offer/$id',
  path: '/offer/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersIdRoute = AppMembersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMembersRoute,
} as any)
const AppCustomerGroupsGroupIdRoute =
  AppCustomerGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AppCustomerGroupsRoute,
  } as any)
const AppCustomerGroupIdRoute = AppCustomerGroupIdRouteImport.update({
  id: '/customer-group/$id',
  path: '/customer-group/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsIdRoute = AppContractsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppContractsRoute,
} as any)
const AppAgentsIdRoute = AppAgentsIdRouteImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsGroupIdIndexRoute =
  AppSupplierGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierGroupsGroupIdRoute,
  } as any)
const AppCustomerGroupsGroupIdIndexRoute =
  AppCustomerGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCustomerGroupsGroupIdRoute,
  } as any)
const AppUserDetailIdRoute = AppUserDetailIdRouteImport.update({
  id: '/user/detail/$id',
  path: '/user/detail/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierDetailIdRoute = AppSupplierDetailIdRouteImport.update({
  id: '/supplier/detail/$id',
  path: '/supplier/detail/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsGroupIdMembersRoute =
  AppSupplierGroupsGroupIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppSupplierGroupsGroupIdRoute,
  } as any)
const AppSupplierGroupsGroupIdCompaniesRoute =
  AppSupplierGroupsGroupIdCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AppSupplierGroupsGroupIdRoute,
  } as any)
const AppRequestsForQuotesIdQuoteRoute =
  AppRequestsForQuotesIdQuoteRouteImport.update({
    id: '/$id_/quote',
    path: '/$id/quote',
    getParentRoute: () => AppRequestsForQuotesRoute,
  } as any)
const AppPortDetailIdRoute = AppPortDetailIdRouteImport.update({
  id: '/port/detail/$id',
  path: '/port/detail/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersDraftIdRoute = AppOrdersDraftIdRouteImport.update({
  id: '/orders_/draft/$id',
  path: '/orders/draft/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrderEditIdRoute = AppOrderEditIdRouteImport.update({
  id: '/order_/edit/$id',
  path: '/order/edit/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOfferIdQuoteRoute = AppOfferIdQuoteRouteImport.update({
  id: '/offer/$id_/quote',
  path: '/offer/$id/quote',
  getParentRoute: () => AppRoute,
} as any)
const AppOfferIdEditRoute = AppOfferIdEditRouteImport.update({
  id: '/offer/$id_/edit',
  path: '/offer/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppDemandDefinitionsCreateSubstepRoute =
  AppDemandDefinitionsCreateSubstepRouteImport.update({
    id: '/create/$substep',
    path: '/create/$substep',
    getParentRoute: () => AppDemandDefinitionsRoute,
  } as any)
const AppCustomerDetailIdRoute = AppCustomerDetailIdRouteImport.update({
  id: '/customer/detail/$id',
  path: '/customer/detail/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerGroupsGroupIdMembersRoute =
  AppCustomerGroupsGroupIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppCustomerGroupsGroupIdRoute,
  } as any)
const AppCustomerGroupsGroupIdCompaniesRoute =
  AppCustomerGroupsGroupIdCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AppCustomerGroupsGroupIdRoute,
  } as any)
const AppSupplierGroupsGroupIdMembersIndexRoute =
  AppSupplierGroupsGroupIdMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierGroupsGroupIdMembersRoute,
  } as any)
const AppSupplierGroupsGroupIdCompaniesIndexRoute =
  AppSupplierGroupsGroupIdCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierGroupsGroupIdCompaniesRoute,
  } as any)
const AppCustomerGroupsGroupIdMembersIndexRoute =
  AppCustomerGroupsGroupIdMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCustomerGroupsGroupIdMembersRoute,
  } as any)
const AppCustomerGroupsGroupIdCompaniesIndexRoute =
  AppCustomerGroupsGroupIdCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCustomerGroupsGroupIdCompaniesRoute,
  } as any)
const AppSupplierGroupsGroupIdMembersUserIdRoute =
  AppSupplierGroupsGroupIdMembersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppSupplierGroupsGroupIdMembersRoute,
  } as any)
const AppSupplierGroupsGroupIdCompaniesCompanyIdRoute =
  AppSupplierGroupsGroupIdCompaniesCompanyIdRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => AppSupplierGroupsGroupIdCompaniesRoute,
  } as any)
const AppDemandDefinitionsEditDefinitionIdSubstepRoute =
  AppDemandDefinitionsEditDefinitionIdSubstepRouteImport.update({
    id: '/edit/$definitionId/$substep',
    path: '/edit/$definitionId/$substep',
    getParentRoute: () => AppDemandDefinitionsRoute,
  } as any)
const AppCustomerGroupsGroupIdMembersUserIdRoute =
  AppCustomerGroupsGroupIdMembersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppCustomerGroupsGroupIdMembersRoute,
  } as any)
const AppCustomerGroupsGroupIdCompaniesCompanyIdRoute =
  AppCustomerGroupsGroupIdCompaniesCompanyIdRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => AppCustomerGroupsGroupIdCompaniesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/onboard-redirect': typeof OnboardRedirectRoute
  '/assignments': typeof AppAssignmentsRoute
  '/compare': typeof AppCompareRoute
  '/contracts': typeof AppContractsRouteWithChildren
  '/customer-groups': typeof AppCustomerGroupsRouteWithChildren
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/demand': typeof AppDemandRoute
  '/demand-definitions': typeof AppDemandDefinitionsRouteWithChildren
  '/integrations': typeof AppIntegrationsRoute
  '/key-ports': typeof AppKeyPortsRoute
  '/me': typeof AppMeRoute
  '/members': typeof AppMembersRouteWithChildren
  '/offers': typeof AppOffersRoute
  '/orders': typeof AppOrdersRoute
  '/ports': typeof AppPortsRoute
  '/products': typeof AppProductsRoute
  '/requests-for-quotes': typeof AppRequestsForQuotesRouteWithChildren
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/statistics': typeof AppStatisticsRoute
  '/supplier-groups': typeof AppSupplierGroupsRouteWithChildren
  '/users': typeof AppUsersRoute
  '/vessels': typeof AppVesselsRoute
  '/agents/$id': typeof AppAgentsIdRoute
  '/contracts/$id': typeof AppContractsIdRoute
  '/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/customer-groups/$groupId': typeof AppCustomerGroupsGroupIdRouteWithChildren
  '/members/$id': typeof AppMembersIdRoute
  '/offer/$id': typeof AppOfferIdRoute
  '/order/$id': typeof AppOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/requests-for-quotes/$id': typeof AppRequestsForQuotesIdRoute
  '/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/supplier-groups/$groupId': typeof AppSupplierGroupsGroupIdRouteWithChildren
  '/vessel/$id': typeof AppVesselIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/contracts/': typeof AppContractsIndexRoute
  '/customer-groups/': typeof AppCustomerGroupsIndexRoute
  '/demand-definitions/': typeof AppDemandDefinitionsIndexRoute
  '/members/': typeof AppMembersIndexRoute
  '/requests-for-quotes/': typeof AppRequestsForQuotesIndexRoute
  '/supplier-groups/': typeof AppSupplierGroupsIndexRoute
  '/customer-groups/$groupId/companies': typeof AppCustomerGroupsGroupIdCompaniesRouteWithChildren
  '/customer-groups/$groupId/members': typeof AppCustomerGroupsGroupIdMembersRouteWithChildren
  '/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/demand-definitions/create/$substep': typeof AppDemandDefinitionsCreateSubstepRoute
  '/offer/$id/edit': typeof AppOfferIdEditRoute
  '/offer/$id/quote': typeof AppOfferIdQuoteRoute
  '/order/edit/$id': typeof AppOrderEditIdRoute
  '/orders/draft/$id': typeof AppOrdersDraftIdRoute
  '/port/detail/$id': typeof AppPortDetailIdRoute
  '/requests-for-quotes/$id/quote': typeof AppRequestsForQuotesIdQuoteRoute
  '/supplier-groups/$groupId/companies': typeof AppSupplierGroupsGroupIdCompaniesRouteWithChildren
  '/supplier-groups/$groupId/members': typeof AppSupplierGroupsGroupIdMembersRouteWithChildren
  '/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/user/detail/$id': typeof AppUserDetailIdRoute
  '/customer-groups/$groupId/': typeof AppCustomerGroupsGroupIdIndexRoute
  '/supplier-groups/$groupId/': typeof AppSupplierGroupsGroupIdIndexRoute
  '/customer-groups/$groupId/companies/$companyId': typeof AppCustomerGroupsGroupIdCompaniesCompanyIdRoute
  '/customer-groups/$groupId/members/$userId': typeof AppCustomerGroupsGroupIdMembersUserIdRoute
  '/demand-definitions/edit/$definitionId/$substep': typeof AppDemandDefinitionsEditDefinitionIdSubstepRoute
  '/supplier-groups/$groupId/companies/$companyId': typeof AppSupplierGroupsGroupIdCompaniesCompanyIdRoute
  '/supplier-groups/$groupId/members/$userId': typeof AppSupplierGroupsGroupIdMembersUserIdRoute
  '/customer-groups/$groupId/companies/': typeof AppCustomerGroupsGroupIdCompaniesIndexRoute
  '/customer-groups/$groupId/members/': typeof AppCustomerGroupsGroupIdMembersIndexRoute
  '/supplier-groups/$groupId/companies/': typeof AppSupplierGroupsGroupIdCompaniesIndexRoute
  '/supplier-groups/$groupId/members/': typeof AppSupplierGroupsGroupIdMembersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/onboard-redirect': typeof OnboardRedirectRoute
  '/assignments': typeof AppAssignmentsRoute
  '/compare': typeof AppCompareRoute
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/demand': typeof AppDemandRoute
  '/integrations': typeof AppIntegrationsRoute
  '/key-ports': typeof AppKeyPortsRoute
  '/me': typeof AppMeRoute
  '/offers': typeof AppOffersRoute
  '/orders': typeof AppOrdersRoute
  '/ports': typeof AppPortsRoute
  '/products': typeof AppProductsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/statistics': typeof AppStatisticsRoute
  '/users': typeof AppUsersRoute
  '/vessels': typeof AppVesselsRoute
  '/agents/$id': typeof AppAgentsIdRoute
  '/contracts/$id': typeof AppContractsIdRoute
  '/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/members/$id': typeof AppMembersIdRoute
  '/offer/$id': typeof AppOfferIdRoute
  '/order/$id': typeof AppOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/requests-for-quotes/$id': typeof AppRequestsForQuotesIdRoute
  '/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/vessel/$id': typeof AppVesselIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/agents': typeof AppAgentsIndexRoute
  '/contracts': typeof AppContractsIndexRoute
  '/customer-groups': typeof AppCustomerGroupsIndexRoute
  '/demand-definitions': typeof AppDemandDefinitionsIndexRoute
  '/members': typeof AppMembersIndexRoute
  '/requests-for-quotes': typeof AppRequestsForQuotesIndexRoute
  '/supplier-groups': typeof AppSupplierGroupsIndexRoute
  '/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/demand-definitions/create/$substep': typeof AppDemandDefinitionsCreateSubstepRoute
  '/offer/$id/edit': typeof AppOfferIdEditRoute
  '/offer/$id/quote': typeof AppOfferIdQuoteRoute
  '/order/edit/$id': typeof AppOrderEditIdRoute
  '/orders/draft/$id': typeof AppOrdersDraftIdRoute
  '/port/detail/$id': typeof AppPortDetailIdRoute
  '/requests-for-quotes/$id/quote': typeof AppRequestsForQuotesIdQuoteRoute
  '/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/user/detail/$id': typeof AppUserDetailIdRoute
  '/customer-groups/$groupId': typeof AppCustomerGroupsGroupIdIndexRoute
  '/supplier-groups/$groupId': typeof AppSupplierGroupsGroupIdIndexRoute
  '/customer-groups/$groupId/companies/$companyId': typeof AppCustomerGroupsGroupIdCompaniesCompanyIdRoute
  '/customer-groups/$groupId/members/$userId': typeof AppCustomerGroupsGroupIdMembersUserIdRoute
  '/demand-definitions/edit/$definitionId/$substep': typeof AppDemandDefinitionsEditDefinitionIdSubstepRoute
  '/supplier-groups/$groupId/companies/$companyId': typeof AppSupplierGroupsGroupIdCompaniesCompanyIdRoute
  '/supplier-groups/$groupId/members/$userId': typeof AppSupplierGroupsGroupIdMembersUserIdRoute
  '/customer-groups/$groupId/companies': typeof AppCustomerGroupsGroupIdCompaniesIndexRoute
  '/customer-groups/$groupId/members': typeof AppCustomerGroupsGroupIdMembersIndexRoute
  '/supplier-groups/$groupId/companies': typeof AppSupplierGroupsGroupIdCompaniesIndexRoute
  '/supplier-groups/$groupId/members': typeof AppSupplierGroupsGroupIdMembersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/onboard-redirect': typeof OnboardRedirectRoute
  '/_app/assignments': typeof AppAssignmentsRoute
  '/_app/compare': typeof AppCompareRoute
  '/_app/contracts': typeof AppContractsRouteWithChildren
  '/_app/customer-groups': typeof AppCustomerGroupsRouteWithChildren
  '/_app/customers': typeof AppCustomersRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/demand': typeof AppDemandRoute
  '/_app/demand-definitions': typeof AppDemandDefinitionsRouteWithChildren
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/key-ports': typeof AppKeyPortsRoute
  '/_app/me': typeof AppMeRoute
  '/_app/members': typeof AppMembersRouteWithChildren
  '/_app/offers': typeof AppOffersRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/ports': typeof AppPortsRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/requests-for-quotes': typeof AppRequestsForQuotesRouteWithChildren
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/statistics': typeof AppStatisticsRoute
  '/_app/supplier-groups': typeof AppSupplierGroupsRouteWithChildren
  '/_app/users': typeof AppUsersRoute
  '/_app/vessels': typeof AppVesselsRoute
  '/_app/agents/$id': typeof AppAgentsIdRoute
  '/_app/contracts/$id': typeof AppContractsIdRoute
  '/_app/customer-group/$id': typeof AppCustomerGroupIdRoute
  '/_app/customer-groups/$groupId': typeof AppCustomerGroupsGroupIdRouteWithChildren
  '/_app/members/$id': typeof AppMembersIdRoute
  '/_app/offer/$id': typeof AppOfferIdRoute
  '/_app/order/$id': typeof AppOrderIdRoute
  '/_app/orders_/new': typeof AppOrdersNewRoute
  '/_app/requests-for-quotes/$id': typeof AppRequestsForQuotesIdRoute
  '/_app/supplier-group/$id': typeof AppSupplierGroupIdRoute
  '/_app/supplier-groups/$groupId': typeof AppSupplierGroupsGroupIdRouteWithChildren
  '/_app/vessel/$id': typeof AppVesselIdRoute
  '/offer/$offerId/approval-request': typeof OfferOfferIdApprovalRequestRoute
  '/onboard/$userId/$token': typeof OnboardUserIdTokenRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/contracts/': typeof AppContractsIndexRoute
  '/_app/customer-groups/': typeof AppCustomerGroupsIndexRoute
  '/_app/demand-definitions/': typeof AppDemandDefinitionsIndexRoute
  '/_app/members/': typeof AppMembersIndexRoute
  '/_app/requests-for-quotes/': typeof AppRequestsForQuotesIndexRoute
  '/_app/supplier-groups/': typeof AppSupplierGroupsIndexRoute
  '/_app/customer-groups/$groupId/companies': typeof AppCustomerGroupsGroupIdCompaniesRouteWithChildren
  '/_app/customer-groups/$groupId/members': typeof AppCustomerGroupsGroupIdMembersRouteWithChildren
  '/_app/customer/detail/$id': typeof AppCustomerDetailIdRoute
  '/_app/demand-definitions/create/$substep': typeof AppDemandDefinitionsCreateSubstepRoute
  '/_app/offer/$id_/edit': typeof AppOfferIdEditRoute
  '/_app/offer/$id_/quote': typeof AppOfferIdQuoteRoute
  '/_app/order_/edit/$id': typeof AppOrderEditIdRoute
  '/_app/orders_/draft/$id': typeof AppOrdersDraftIdRoute
  '/_app/port/detail/$id': typeof AppPortDetailIdRoute
  '/_app/requests-for-quotes/$id_/quote': typeof AppRequestsForQuotesIdQuoteRoute
  '/_app/supplier-groups/$groupId/companies': typeof AppSupplierGroupsGroupIdCompaniesRouteWithChildren
  '/_app/supplier-groups/$groupId/members': typeof AppSupplierGroupsGroupIdMembersRouteWithChildren
  '/_app/supplier/detail/$id': typeof AppSupplierDetailIdRoute
  '/_app/user/detail/$id': typeof AppUserDetailIdRoute
  '/_app/customer-groups/$groupId/': typeof AppCustomerGroupsGroupIdIndexRoute
  '/_app/supplier-groups/$groupId/': typeof AppSupplierGroupsGroupIdIndexRoute
  '/_app/customer-groups/$groupId/companies/$companyId': typeof AppCustomerGroupsGroupIdCompaniesCompanyIdRoute
  '/_app/customer-groups/$groupId/members/$userId': typeof AppCustomerGroupsGroupIdMembersUserIdRoute
  '/_app/demand-definitions/edit/$definitionId/$substep': typeof AppDemandDefinitionsEditDefinitionIdSubstepRoute
  '/_app/supplier-groups/$groupId/companies/$companyId': typeof AppSupplierGroupsGroupIdCompaniesCompanyIdRoute
  '/_app/supplier-groups/$groupId/members/$userId': typeof AppSupplierGroupsGroupIdMembersUserIdRoute
  '/_app/customer-groups/$groupId/companies/': typeof AppCustomerGroupsGroupIdCompaniesIndexRoute
  '/_app/customer-groups/$groupId/members/': typeof AppCustomerGroupsGroupIdMembersIndexRoute
  '/_app/supplier-groups/$groupId/companies/': typeof AppSupplierGroupsGroupIdCompaniesIndexRoute
  '/_app/supplier-groups/$groupId/members/': typeof AppSupplierGroupsGroupIdMembersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/login'
    | '/logout'
    | '/onboard-redirect'
    | '/assignments'
    | '/compare'
    | '/contracts'
    | '/customer-groups'
    | '/customers'
    | '/dashboard'
    | '/demand'
    | '/integrations'
    | '/key-ports'
    | '/me'
    | '/members'
    | '/offers'
    | '/orders'
    | '/ports'
    | '/products'
    | '/requests-for-quotes'
    | '/search'
    | '/settings'
    | '/statistics'
    | '/supplier-groups'
    | '/users'
    | '/vessels'
    | '/agents/$id'
    | '/contracts/$id'
    | '/customer-group/$id'
    | '/customer-groups/$groupId'
    | '/members/$id'
    | '/offer/$id'
    | '/order/$id'
    | '/orders/new'
    | '/requests-for-quotes/$id'
    | '/supplier-group/$id'
    | '/supplier-groups/$groupId'
    | '/vessel/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/agents/'
    | '/contracts/'
    | '/customer-groups/'
    | '/demand-definitions/'
    | '/members/'
    | '/requests-for-quotes/'
    | '/supplier-groups/'
    | '/customer-groups/$groupId/companies'
    | '/customer-groups/$groupId/members'
    | '/customer/detail/$id'
    | '/demand-definitions/create/$substep'
    | '/offer/$id/edit'
    | '/offer/$id/quote'
    | '/order/edit/$id'
    | '/orders/draft/$id'
    | '/port/detail/$id'
    | '/requests-for-quotes/$id/quote'
    | '/supplier-groups/$groupId/companies'
    | '/supplier-groups/$groupId/members'
    | '/supplier/detail/$id'
    | '/user/detail/$id'
    | '/customer-groups/$groupId/'
    | '/supplier-groups/$groupId/'
    | '/customer-groups/$groupId/companies/$companyId'
    | '/customer-groups/$groupId/members/$userId'
    | '/demand-definitions/edit/$definitionId/$substep'
    | '/supplier-groups/$groupId/companies/$companyId'
    | '/supplier-groups/$groupId/members/$userId'
    | '/customer-groups/$groupId/companies/'
    | '/customer-groups/$groupId/members/'
    | '/supplier-groups/$groupId/companies/'
    | '/supplier-groups/$groupId/members/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/login'
    | '/logout'
    | '/onboard-redirect'
    | '/assignments'
    | '/compare'
    | '/customers'
    | '/dashboard'
    | '/demand'
    | '/integrations'
    | '/key-ports'
    | '/me'
    | '/offers'
    | '/orders'
    | '/ports'
    | '/products'
    | '/search'
    | '/settings'
    | '/statistics'
    | '/users'
    | '/vessels'
    | '/agents/$id'
    | '/contracts/$id'
    | '/customer-group/$id'
    | '/members/$id'
    | '/offer/$id'
    | '/order/$id'
    | '/orders/new'
    | '/requests-for-quotes/$id'
    | '/supplier-group/$id'
    | '/vessel/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/agents'
    | '/contracts'
    | '/customer-groups'
    | '/demand-definitions'
    | '/members'
    | '/requests-for-quotes'
    | '/supplier-groups'
    | '/customer/detail/$id'
    | '/demand-definitions/create/$substep'
    | '/offer/$id/edit'
    | '/offer/$id/quote'
    | '/order/edit/$id'
    | '/orders/draft/$id'
    | '/port/detail/$id'
    | '/requests-for-quotes/$id/quote'
    | '/supplier/detail/$id'
    | '/user/detail/$id'
    | '/customer-groups/$groupId'
    | '/supplier-groups/$groupId'
    | '/customer-groups/$groupId/companies/$companyId'
    | '/customer-groups/$groupId/members/$userId'
    | '/demand-definitions/edit/$definitionId/$substep'
    | '/supplier-groups/$groupId/companies/$companyId'
    | '/supplier-groups/$groupId/members/$userId'
    | '/customer-groups/$groupId/companies'
    | '/customer-groups/$groupId/members'
    | '/supplier-groups/$groupId/companies'
    | '/supplier-groups/$groupId/members'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/auth'
    | '/login'
    | '/logout'
    | '/onboard-redirect'
    | '/_app/assignments'
    | '/_app/compare'
    | '/_app/contracts'
    | '/_app/customer-groups'
    | '/_app/customers'
    | '/_app/dashboard'
    | '/_app/demand'
    | '/_app/demand-definitions'
    | '/_app/integrations'
    | '/_app/key-ports'
    | '/_app/me'
    | '/_app/members'
    | '/_app/offers'
    | '/_app/orders'
    | '/_app/ports'
    | '/_app/products'
    | '/_app/requests-for-quotes'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/statistics'
    | '/_app/supplier-groups'
    | '/_app/users'
    | '/_app/vessels'
    | '/_app/agents/$id'
    | '/_app/contracts/$id'
    | '/_app/customer-group/$id'
    | '/_app/customer-groups/$groupId'
    | '/_app/members/$id'
    | '/_app/offer/$id'
    | '/_app/order/$id'
    | '/_app/orders_/new'
    | '/_app/requests-for-quotes/$id'
    | '/_app/supplier-group/$id'
    | '/_app/supplier-groups/$groupId'
    | '/_app/vessel/$id'
    | '/offer/$offerId/approval-request'
    | '/onboard/$userId/$token'
    | '/_app/agents/'
    | '/_app/contracts/'
    | '/_app/customer-groups/'
    | '/_app/demand-definitions/'
    | '/_app/members/'
    | '/_app/requests-for-quotes/'
    | '/_app/supplier-groups/'
    | '/_app/customer-groups/$groupId/companies'
    | '/_app/customer-groups/$groupId/members'
    | '/_app/customer/detail/$id'
    | '/_app/demand-definitions/create/$substep'
    | '/_app/offer/$id_/edit'
    | '/_app/offer/$id_/quote'
    | '/_app/order_/edit/$id'
    | '/_app/orders_/draft/$id'
    | '/_app/port/detail/$id'
    | '/_app/requests-for-quotes/$id_/quote'
    | '/_app/supplier-groups/$groupId/companies'
    | '/_app/supplier-groups/$groupId/members'
    | '/_app/supplier/detail/$id'
    | '/_app/user/detail/$id'
    | '/_app/customer-groups/$groupId/'
    | '/_app/supplier-groups/$groupId/'
    | '/_app/customer-groups/$groupId/companies/$companyId'
    | '/_app/customer-groups/$groupId/members/$userId'
    | '/_app/demand-definitions/edit/$definitionId/$substep'
    | '/_app/supplier-groups/$groupId/companies/$companyId'
    | '/_app/supplier-groups/$groupId/members/$userId'
    | '/_app/customer-groups/$groupId/companies/'
    | '/_app/customer-groups/$groupId/members/'
    | '/_app/supplier-groups/$groupId/companies/'
    | '/_app/supplier-groups/$groupId/members/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  OnboardRedirectRoute: typeof OnboardRedirectRoute
  OfferOfferIdApprovalRequestRoute: typeof OfferOfferIdApprovalRequestRoute
  OnboardUserIdTokenRoute: typeof OnboardUserIdTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboard-redirect': {
      id: '/onboard-redirect'
      path: '/onboard-redirect'
      fullPath: '/onboard-redirect'
      preLoaderRoute: typeof OnboardRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/vessels': {
      id: '/_app/vessels'
      path: '/vessels'
      fullPath: '/vessels'
      preLoaderRoute: typeof AppVesselsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups': {
      id: '/_app/supplier-groups'
      path: '/supplier-groups'
      fullPath: '/supplier-groups'
      preLoaderRoute: typeof AppSupplierGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statistics': {
      id: '/_app/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests-for-quotes': {
      id: '/_app/requests-for-quotes'
      path: '/requests-for-quotes'
      fullPath: '/requests-for-quotes'
      preLoaderRoute: typeof AppRequestsForQuotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ports': {
      id: '/_app/ports'
      path: '/ports'
      fullPath: '/ports'
      preLoaderRoute: typeof AppPortsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers': {
      id: '/_app/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AppOffersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/key-ports': {
      id: '/_app/key-ports'
      path: '/key-ports'
      fullPath: '/key-ports'
      preLoaderRoute: typeof AppKeyPortsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demand-definitions': {
      id: '/_app/demand-definitions'
      path: '/demand-definitions'
      fullPath: '/demand-definitions'
      preLoaderRoute: typeof AppDemandDefinitionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demand': {
      id: '/_app/demand'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof AppDemandRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-groups': {
      id: '/_app/customer-groups'
      path: '/customer-groups'
      fullPath: '/customer-groups'
      preLoaderRoute: typeof AppCustomerGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts': {
      id: '/_app/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof AppContractsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compare': {
      id: '/_app/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof AppCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assignments': {
      id: '/_app/assignments'
      path: '/assignments'
      fullPath: '/assignments'
      preLoaderRoute: typeof AppAssignmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups/': {
      id: '/_app/supplier-groups/'
      path: '/'
      fullPath: '/supplier-groups/'
      preLoaderRoute: typeof AppSupplierGroupsIndexRouteImport
      parentRoute: typeof AppSupplierGroupsRoute
    }
    '/_app/requests-for-quotes/': {
      id: '/_app/requests-for-quotes/'
      path: '/'
      fullPath: '/requests-for-quotes/'
      preLoaderRoute: typeof AppRequestsForQuotesIndexRouteImport
      parentRoute: typeof AppRequestsForQuotesRoute
    }
    '/_app/members/': {
      id: '/_app/members/'
      path: '/'
      fullPath: '/members/'
      preLoaderRoute: typeof AppMembersIndexRouteImport
      parentRoute: typeof AppMembersRoute
    }
    '/_app/demand-definitions/': {
      id: '/_app/demand-definitions/'
      path: '/'
      fullPath: '/demand-definitions/'
      preLoaderRoute: typeof AppDemandDefinitionsIndexRouteImport
      parentRoute: typeof AppDemandDefinitionsRoute
    }
    '/_app/customer-groups/': {
      id: '/_app/customer-groups/'
      path: '/'
      fullPath: '/customer-groups/'
      preLoaderRoute: typeof AppCustomerGroupsIndexRouteImport
      parentRoute: typeof AppCustomerGroupsRoute
    }
    '/_app/contracts/': {
      id: '/_app/contracts/'
      path: '/'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AppContractsIndexRouteImport
      parentRoute: typeof AppContractsRoute
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboard/$userId/$token': {
      id: '/onboard/$userId/$token'
      path: '/onboard/$userId/$token'
      fullPath: '/onboard/$userId/$token'
      preLoaderRoute: typeof OnboardUserIdTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offer/$offerId/approval-request': {
      id: '/offer/$offerId/approval-request'
      path: '/offer/$offerId/approval-request'
      fullPath: '/offer/$offerId/approval-request'
      preLoaderRoute: typeof OfferOfferIdApprovalRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/vessel/$id': {
      id: '/_app/vessel/$id'
      path: '/vessel/$id'
      fullPath: '/vessel/$id'
      preLoaderRoute: typeof AppVesselIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups/$groupId': {
      id: '/_app/supplier-groups/$groupId'
      path: '/$groupId'
      fullPath: '/supplier-groups/$groupId'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdRouteImport
      parentRoute: typeof AppSupplierGroupsRoute
    }
    '/_app/supplier-group/$id': {
      id: '/_app/supplier-group/$id'
      path: '/supplier-group/$id'
      fullPath: '/supplier-group/$id'
      preLoaderRoute: typeof AppSupplierGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests-for-quotes/$id': {
      id: '/_app/requests-for-quotes/$id'
      path: '/$id'
      fullPath: '/requests-for-quotes/$id'
      preLoaderRoute: typeof AppRequestsForQuotesIdRouteImport
      parentRoute: typeof AppRequestsForQuotesRoute
    }
    '/_app/orders_/new': {
      id: '/_app/orders_/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/order/$id': {
      id: '/_app/order/$id'
      path: '/order/$id'
      fullPath: '/order/$id'
      preLoaderRoute: typeof AppOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offer/$id': {
      id: '/_app/offer/$id'
      path: '/offer/$id'
      fullPath: '/offer/$id'
      preLoaderRoute: typeof AppOfferIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members/$id': {
      id: '/_app/members/$id'
      path: '/$id'
      fullPath: '/members/$id'
      preLoaderRoute: typeof AppMembersIdRouteImport
      parentRoute: typeof AppMembersRoute
    }
    '/_app/customer-groups/$groupId': {
      id: '/_app/customer-groups/$groupId'
      path: '/$groupId'
      fullPath: '/customer-groups/$groupId'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdRouteImport
      parentRoute: typeof AppCustomerGroupsRoute
    }
    '/_app/customer-group/$id': {
      id: '/_app/customer-group/$id'
      path: '/customer-group/$id'
      fullPath: '/customer-group/$id'
      preLoaderRoute: typeof AppCustomerGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts/$id': {
      id: '/_app/contracts/$id'
      path: '/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof AppContractsIdRouteImport
      parentRoute: typeof AppContractsRoute
    }
    '/_app/agents/$id': {
      id: '/_app/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AppAgentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups/$groupId/': {
      id: '/_app/supplier-groups/$groupId/'
      path: '/'
      fullPath: '/supplier-groups/$groupId/'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdIndexRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdRoute
    }
    '/_app/customer-groups/$groupId/': {
      id: '/_app/customer-groups/$groupId/'
      path: '/'
      fullPath: '/customer-groups/$groupId/'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdIndexRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdRoute
    }
    '/_app/user/detail/$id': {
      id: '/_app/user/detail/$id'
      path: '/user/detail/$id'
      fullPath: '/user/detail/$id'
      preLoaderRoute: typeof AppUserDetailIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier/detail/$id': {
      id: '/_app/supplier/detail/$id'
      path: '/supplier/detail/$id'
      fullPath: '/supplier/detail/$id'
      preLoaderRoute: typeof AppSupplierDetailIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups/$groupId/members': {
      id: '/_app/supplier-groups/$groupId/members'
      path: '/members'
      fullPath: '/supplier-groups/$groupId/members'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdMembersRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdRoute
    }
    '/_app/supplier-groups/$groupId/companies': {
      id: '/_app/supplier-groups/$groupId/companies'
      path: '/companies'
      fullPath: '/supplier-groups/$groupId/companies'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdCompaniesRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdRoute
    }
    '/_app/requests-for-quotes/$id_/quote': {
      id: '/_app/requests-for-quotes/$id_/quote'
      path: '/$id/quote'
      fullPath: '/requests-for-quotes/$id/quote'
      preLoaderRoute: typeof AppRequestsForQuotesIdQuoteRouteImport
      parentRoute: typeof AppRequestsForQuotesRoute
    }
    '/_app/port/detail/$id': {
      id: '/_app/port/detail/$id'
      path: '/port/detail/$id'
      fullPath: '/port/detail/$id'
      preLoaderRoute: typeof AppPortDetailIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders_/draft/$id': {
      id: '/_app/orders_/draft/$id'
      path: '/orders/draft/$id'
      fullPath: '/orders/draft/$id'
      preLoaderRoute: typeof AppOrdersDraftIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/order_/edit/$id': {
      id: '/_app/order_/edit/$id'
      path: '/order/edit/$id'
      fullPath: '/order/edit/$id'
      preLoaderRoute: typeof AppOrderEditIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offer/$id_/quote': {
      id: '/_app/offer/$id_/quote'
      path: '/offer/$id/quote'
      fullPath: '/offer/$id/quote'
      preLoaderRoute: typeof AppOfferIdQuoteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offer/$id_/edit': {
      id: '/_app/offer/$id_/edit'
      path: '/offer/$id/edit'
      fullPath: '/offer/$id/edit'
      preLoaderRoute: typeof AppOfferIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demand-definitions/create/$substep': {
      id: '/_app/demand-definitions/create/$substep'
      path: '/create/$substep'
      fullPath: '/demand-definitions/create/$substep'
      preLoaderRoute: typeof AppDemandDefinitionsCreateSubstepRouteImport
      parentRoute: typeof AppDemandDefinitionsRoute
    }
    '/_app/customer/detail/$id': {
      id: '/_app/customer/detail/$id'
      path: '/customer/detail/$id'
      fullPath: '/customer/detail/$id'
      preLoaderRoute: typeof AppCustomerDetailIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-groups/$groupId/members': {
      id: '/_app/customer-groups/$groupId/members'
      path: '/members'
      fullPath: '/customer-groups/$groupId/members'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdMembersRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdRoute
    }
    '/_app/customer-groups/$groupId/companies': {
      id: '/_app/customer-groups/$groupId/companies'
      path: '/companies'
      fullPath: '/customer-groups/$groupId/companies'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdCompaniesRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdRoute
    }
    '/_app/supplier-groups/$groupId/members/': {
      id: '/_app/supplier-groups/$groupId/members/'
      path: '/'
      fullPath: '/supplier-groups/$groupId/members/'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdMembersIndexRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdMembersRoute
    }
    '/_app/supplier-groups/$groupId/companies/': {
      id: '/_app/supplier-groups/$groupId/companies/'
      path: '/'
      fullPath: '/supplier-groups/$groupId/companies/'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdCompaniesIndexRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdCompaniesRoute
    }
    '/_app/customer-groups/$groupId/members/': {
      id: '/_app/customer-groups/$groupId/members/'
      path: '/'
      fullPath: '/customer-groups/$groupId/members/'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdMembersIndexRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdMembersRoute
    }
    '/_app/customer-groups/$groupId/companies/': {
      id: '/_app/customer-groups/$groupId/companies/'
      path: '/'
      fullPath: '/customer-groups/$groupId/companies/'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdCompaniesIndexRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdCompaniesRoute
    }
    '/_app/supplier-groups/$groupId/members/$userId': {
      id: '/_app/supplier-groups/$groupId/members/$userId'
      path: '/$userId'
      fullPath: '/supplier-groups/$groupId/members/$userId'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdMembersUserIdRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdMembersRoute
    }
    '/_app/supplier-groups/$groupId/companies/$companyId': {
      id: '/_app/supplier-groups/$groupId/companies/$companyId'
      path: '/$companyId'
      fullPath: '/supplier-groups/$groupId/companies/$companyId'
      preLoaderRoute: typeof AppSupplierGroupsGroupIdCompaniesCompanyIdRouteImport
      parentRoute: typeof AppSupplierGroupsGroupIdCompaniesRoute
    }
    '/_app/demand-definitions/edit/$definitionId/$substep': {
      id: '/_app/demand-definitions/edit/$definitionId/$substep'
      path: '/edit/$definitionId/$substep'
      fullPath: '/demand-definitions/edit/$definitionId/$substep'
      preLoaderRoute: typeof AppDemandDefinitionsEditDefinitionIdSubstepRouteImport
      parentRoute: typeof AppDemandDefinitionsRoute
    }
    '/_app/customer-groups/$groupId/members/$userId': {
      id: '/_app/customer-groups/$groupId/members/$userId'
      path: '/$userId'
      fullPath: '/customer-groups/$groupId/members/$userId'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdMembersUserIdRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdMembersRoute
    }
    '/_app/customer-groups/$groupId/companies/$companyId': {
      id: '/_app/customer-groups/$groupId/companies/$companyId'
      path: '/$companyId'
      fullPath: '/customer-groups/$groupId/companies/$companyId'
      preLoaderRoute: typeof AppCustomerGroupsGroupIdCompaniesCompanyIdRouteImport
      parentRoute: typeof AppCustomerGroupsGroupIdCompaniesRoute
    }
  }
}

interface AppContractsRouteChildren {
  AppContractsIdRoute: typeof AppContractsIdRoute
  AppContractsIndexRoute: typeof AppContractsIndexRoute
}

const AppContractsRouteChildren: AppContractsRouteChildren = {
  AppContractsIdRoute: AppContractsIdRoute,
  AppContractsIndexRoute: AppContractsIndexRoute,
}

const AppContractsRouteWithChildren = AppContractsRoute._addFileChildren(
  AppContractsRouteChildren,
)

interface AppCustomerGroupsGroupIdCompaniesRouteChildren {
  AppCustomerGroupsGroupIdCompaniesCompanyIdRoute: typeof AppCustomerGroupsGroupIdCompaniesCompanyIdRoute
  AppCustomerGroupsGroupIdCompaniesIndexRoute: typeof AppCustomerGroupsGroupIdCompaniesIndexRoute
}

const AppCustomerGroupsGroupIdCompaniesRouteChildren: AppCustomerGroupsGroupIdCompaniesRouteChildren =
  {
    AppCustomerGroupsGroupIdCompaniesCompanyIdRoute:
      AppCustomerGroupsGroupIdCompaniesCompanyIdRoute,
    AppCustomerGroupsGroupIdCompaniesIndexRoute:
      AppCustomerGroupsGroupIdCompaniesIndexRoute,
  }

const AppCustomerGroupsGroupIdCompaniesRouteWithChildren =
  AppCustomerGroupsGroupIdCompaniesRoute._addFileChildren(
    AppCustomerGroupsGroupIdCompaniesRouteChildren,
  )

interface AppCustomerGroupsGroupIdMembersRouteChildren {
  AppCustomerGroupsGroupIdMembersUserIdRoute: typeof AppCustomerGroupsGroupIdMembersUserIdRoute
  AppCustomerGroupsGroupIdMembersIndexRoute: typeof AppCustomerGroupsGroupIdMembersIndexRoute
}

const AppCustomerGroupsGroupIdMembersRouteChildren: AppCustomerGroupsGroupIdMembersRouteChildren =
  {
    AppCustomerGroupsGroupIdMembersUserIdRoute:
      AppCustomerGroupsGroupIdMembersUserIdRoute,
    AppCustomerGroupsGroupIdMembersIndexRoute:
      AppCustomerGroupsGroupIdMembersIndexRoute,
  }

const AppCustomerGroupsGroupIdMembersRouteWithChildren =
  AppCustomerGroupsGroupIdMembersRoute._addFileChildren(
    AppCustomerGroupsGroupIdMembersRouteChildren,
  )

interface AppCustomerGroupsGroupIdRouteChildren {
  AppCustomerGroupsGroupIdCompaniesRoute: typeof AppCustomerGroupsGroupIdCompaniesRouteWithChildren
  AppCustomerGroupsGroupIdMembersRoute: typeof AppCustomerGroupsGroupIdMembersRouteWithChildren
  AppCustomerGroupsGroupIdIndexRoute: typeof AppCustomerGroupsGroupIdIndexRoute
}

const AppCustomerGroupsGroupIdRouteChildren: AppCustomerGroupsGroupIdRouteChildren =
  {
    AppCustomerGroupsGroupIdCompaniesRoute:
      AppCustomerGroupsGroupIdCompaniesRouteWithChildren,
    AppCustomerGroupsGroupIdMembersRoute:
      AppCustomerGroupsGroupIdMembersRouteWithChildren,
    AppCustomerGroupsGroupIdIndexRoute: AppCustomerGroupsGroupIdIndexRoute,
  }

const AppCustomerGroupsGroupIdRouteWithChildren =
  AppCustomerGroupsGroupIdRoute._addFileChildren(
    AppCustomerGroupsGroupIdRouteChildren,
  )

interface AppCustomerGroupsRouteChildren {
  AppCustomerGroupsGroupIdRoute: typeof AppCustomerGroupsGroupIdRouteWithChildren
  AppCustomerGroupsIndexRoute: typeof AppCustomerGroupsIndexRoute
}

const AppCustomerGroupsRouteChildren: AppCustomerGroupsRouteChildren = {
  AppCustomerGroupsGroupIdRoute: AppCustomerGroupsGroupIdRouteWithChildren,
  AppCustomerGroupsIndexRoute: AppCustomerGroupsIndexRoute,
}

const AppCustomerGroupsRouteWithChildren =
  AppCustomerGroupsRoute._addFileChildren(AppCustomerGroupsRouteChildren)

interface AppDemandDefinitionsRouteChildren {
  AppDemandDefinitionsIndexRoute: typeof AppDemandDefinitionsIndexRoute
  AppDemandDefinitionsCreateSubstepRoute: typeof AppDemandDefinitionsCreateSubstepRoute
  AppDemandDefinitionsEditDefinitionIdSubstepRoute: typeof AppDemandDefinitionsEditDefinitionIdSubstepRoute
}

const AppDemandDefinitionsRouteChildren: AppDemandDefinitionsRouteChildren = {
  AppDemandDefinitionsIndexRoute: AppDemandDefinitionsIndexRoute,
  AppDemandDefinitionsCreateSubstepRoute:
    AppDemandDefinitionsCreateSubstepRoute,
  AppDemandDefinitionsEditDefinitionIdSubstepRoute:
    AppDemandDefinitionsEditDefinitionIdSubstepRoute,
}

const AppDemandDefinitionsRouteWithChildren =
  AppDemandDefinitionsRoute._addFileChildren(AppDemandDefinitionsRouteChildren)

interface AppMembersRouteChildren {
  AppMembersIdRoute: typeof AppMembersIdRoute
  AppMembersIndexRoute: typeof AppMembersIndexRoute
}

const AppMembersRouteChildren: AppMembersRouteChildren = {
  AppMembersIdRoute: AppMembersIdRoute,
  AppMembersIndexRoute: AppMembersIndexRoute,
}

const AppMembersRouteWithChildren = AppMembersRoute._addFileChildren(
  AppMembersRouteChildren,
)

interface AppRequestsForQuotesRouteChildren {
  AppRequestsForQuotesIdRoute: typeof AppRequestsForQuotesIdRoute
  AppRequestsForQuotesIndexRoute: typeof AppRequestsForQuotesIndexRoute
  AppRequestsForQuotesIdQuoteRoute: typeof AppRequestsForQuotesIdQuoteRoute
}

const AppRequestsForQuotesRouteChildren: AppRequestsForQuotesRouteChildren = {
  AppRequestsForQuotesIdRoute: AppRequestsForQuotesIdRoute,
  AppRequestsForQuotesIndexRoute: AppRequestsForQuotesIndexRoute,
  AppRequestsForQuotesIdQuoteRoute: AppRequestsForQuotesIdQuoteRoute,
}

const AppRequestsForQuotesRouteWithChildren =
  AppRequestsForQuotesRoute._addFileChildren(AppRequestsForQuotesRouteChildren)

interface AppSupplierGroupsGroupIdCompaniesRouteChildren {
  AppSupplierGroupsGroupIdCompaniesCompanyIdRoute: typeof AppSupplierGroupsGroupIdCompaniesCompanyIdRoute
  AppSupplierGroupsGroupIdCompaniesIndexRoute: typeof AppSupplierGroupsGroupIdCompaniesIndexRoute
}

const AppSupplierGroupsGroupIdCompaniesRouteChildren: AppSupplierGroupsGroupIdCompaniesRouteChildren =
  {
    AppSupplierGroupsGroupIdCompaniesCompanyIdRoute:
      AppSupplierGroupsGroupIdCompaniesCompanyIdRoute,
    AppSupplierGroupsGroupIdCompaniesIndexRoute:
      AppSupplierGroupsGroupIdCompaniesIndexRoute,
  }

const AppSupplierGroupsGroupIdCompaniesRouteWithChildren =
  AppSupplierGroupsGroupIdCompaniesRoute._addFileChildren(
    AppSupplierGroupsGroupIdCompaniesRouteChildren,
  )

interface AppSupplierGroupsGroupIdMembersRouteChildren {
  AppSupplierGroupsGroupIdMembersUserIdRoute: typeof AppSupplierGroupsGroupIdMembersUserIdRoute
  AppSupplierGroupsGroupIdMembersIndexRoute: typeof AppSupplierGroupsGroupIdMembersIndexRoute
}

const AppSupplierGroupsGroupIdMembersRouteChildren: AppSupplierGroupsGroupIdMembersRouteChildren =
  {
    AppSupplierGroupsGroupIdMembersUserIdRoute:
      AppSupplierGroupsGroupIdMembersUserIdRoute,
    AppSupplierGroupsGroupIdMembersIndexRoute:
      AppSupplierGroupsGroupIdMembersIndexRoute,
  }

const AppSupplierGroupsGroupIdMembersRouteWithChildren =
  AppSupplierGroupsGroupIdMembersRoute._addFileChildren(
    AppSupplierGroupsGroupIdMembersRouteChildren,
  )

interface AppSupplierGroupsGroupIdRouteChildren {
  AppSupplierGroupsGroupIdCompaniesRoute: typeof AppSupplierGroupsGroupIdCompaniesRouteWithChildren
  AppSupplierGroupsGroupIdMembersRoute: typeof AppSupplierGroupsGroupIdMembersRouteWithChildren
  AppSupplierGroupsGroupIdIndexRoute: typeof AppSupplierGroupsGroupIdIndexRoute
}

const AppSupplierGroupsGroupIdRouteChildren: AppSupplierGroupsGroupIdRouteChildren =
  {
    AppSupplierGroupsGroupIdCompaniesRoute:
      AppSupplierGroupsGroupIdCompaniesRouteWithChildren,
    AppSupplierGroupsGroupIdMembersRoute:
      AppSupplierGroupsGroupIdMembersRouteWithChildren,
    AppSupplierGroupsGroupIdIndexRoute: AppSupplierGroupsGroupIdIndexRoute,
  }

const AppSupplierGroupsGroupIdRouteWithChildren =
  AppSupplierGroupsGroupIdRoute._addFileChildren(
    AppSupplierGroupsGroupIdRouteChildren,
  )

interface AppSupplierGroupsRouteChildren {
  AppSupplierGroupsGroupIdRoute: typeof AppSupplierGroupsGroupIdRouteWithChildren
  AppSupplierGroupsIndexRoute: typeof AppSupplierGroupsIndexRoute
}

const AppSupplierGroupsRouteChildren: AppSupplierGroupsRouteChildren = {
  AppSupplierGroupsGroupIdRoute: AppSupplierGroupsGroupIdRouteWithChildren,
  AppSupplierGroupsIndexRoute: AppSupplierGroupsIndexRoute,
}

const AppSupplierGroupsRouteWithChildren =
  AppSupplierGroupsRoute._addFileChildren(AppSupplierGroupsRouteChildren)

interface AppRouteChildren {
  AppAssignmentsRoute: typeof AppAssignmentsRoute
  AppCompareRoute: typeof AppCompareRoute
  AppContractsRoute: typeof AppContractsRouteWithChildren
  AppCustomerGroupsRoute: typeof AppCustomerGroupsRouteWithChildren
  AppCustomersRoute: typeof AppCustomersRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDemandRoute: typeof AppDemandRoute
  AppDemandDefinitionsRoute: typeof AppDemandDefinitionsRouteWithChildren
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppKeyPortsRoute: typeof AppKeyPortsRoute
  AppMeRoute: typeof AppMeRoute
  AppMembersRoute: typeof AppMembersRouteWithChildren
  AppOffersRoute: typeof AppOffersRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppPortsRoute: typeof AppPortsRoute
  AppProductsRoute: typeof AppProductsRoute
  AppRequestsForQuotesRoute: typeof AppRequestsForQuotesRouteWithChildren
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppSupplierGroupsRoute: typeof AppSupplierGroupsRouteWithChildren
  AppUsersRoute: typeof AppUsersRoute
  AppVesselsRoute: typeof AppVesselsRoute
  AppAgentsIdRoute: typeof AppAgentsIdRoute
  AppCustomerGroupIdRoute: typeof AppCustomerGroupIdRoute
  AppOfferIdRoute: typeof AppOfferIdRoute
  AppOrderIdRoute: typeof AppOrderIdRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppSupplierGroupIdRoute: typeof AppSupplierGroupIdRoute
  AppVesselIdRoute: typeof AppVesselIdRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppCustomerDetailIdRoute: typeof AppCustomerDetailIdRoute
  AppOfferIdEditRoute: typeof AppOfferIdEditRoute
  AppOfferIdQuoteRoute: typeof AppOfferIdQuoteRoute
  AppOrderEditIdRoute: typeof AppOrderEditIdRoute
  AppOrdersDraftIdRoute: typeof AppOrdersDraftIdRoute
  AppPortDetailIdRoute: typeof AppPortDetailIdRoute
  AppSupplierDetailIdRoute: typeof AppSupplierDetailIdRoute
  AppUserDetailIdRoute: typeof AppUserDetailIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAssignmentsRoute: AppAssignmentsRoute,
  AppCompareRoute: AppCompareRoute,
  AppContractsRoute: AppContractsRouteWithChildren,
  AppCustomerGroupsRoute: AppCustomerGroupsRouteWithChildren,
  AppCustomersRoute: AppCustomersRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDemandRoute: AppDemandRoute,
  AppDemandDefinitionsRoute: AppDemandDefinitionsRouteWithChildren,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppKeyPortsRoute: AppKeyPortsRoute,
  AppMeRoute: AppMeRoute,
  AppMembersRoute: AppMembersRouteWithChildren,
  AppOffersRoute: AppOffersRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppPortsRoute: AppPortsRoute,
  AppProductsRoute: AppProductsRoute,
  AppRequestsForQuotesRoute: AppRequestsForQuotesRouteWithChildren,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStatisticsRoute: AppStatisticsRoute,
  AppSupplierGroupsRoute: AppSupplierGroupsRouteWithChildren,
  AppUsersRoute: AppUsersRoute,
  AppVesselsRoute: AppVesselsRoute,
  AppAgentsIdRoute: AppAgentsIdRoute,
  AppCustomerGroupIdRoute: AppCustomerGroupIdRoute,
  AppOfferIdRoute: AppOfferIdRoute,
  AppOrderIdRoute: AppOrderIdRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppSupplierGroupIdRoute: AppSupplierGroupIdRoute,
  AppVesselIdRoute: AppVesselIdRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppCustomerDetailIdRoute: AppCustomerDetailIdRoute,
  AppOfferIdEditRoute: AppOfferIdEditRoute,
  AppOfferIdQuoteRoute: AppOfferIdQuoteRoute,
  AppOrderEditIdRoute: AppOrderEditIdRoute,
  AppOrdersDraftIdRoute: AppOrdersDraftIdRoute,
  AppPortDetailIdRoute: AppPortDetailIdRoute,
  AppSupplierDetailIdRoute: AppSupplierDetailIdRoute,
  AppUserDetailIdRoute: AppUserDetailIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  OnboardRedirectRoute: OnboardRedirectRoute,
  OfferOfferIdApprovalRequestRoute: OfferOfferIdApprovalRequestRoute,
  OnboardUserIdTokenRoute: OnboardUserIdTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
